module.exports = __webpack_public_path__ + "media/src/img/right-flower-b788f720e8ad5c6394fbf44f9a1065c0.png";